import { FC, ReactNode } from "react";

import {
	Box,
	Typography,
	useTheme,
} from "@mui/material";

import { tokens } from "@/components/Application/theme";

interface Props {
	dashboardHeader: string | ReactNode;
	dashboardSubheader?: string | ReactNode;
	buttons?: ReactNode;
}

const DashboardGrid: FC<Props> = ({
	children,
	dashboardHeader = "Dashboard",
	dashboardSubheader,
	buttons,
}) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	return (
		<Box sx={{ padding: "1rem 2rem", backgroundColor: colors.grey[900] }}>
			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					justifyContent: { xs: "start", md: "space-between" },
					alignItems: { xs: "start", md: "center" },
					marginBottom: "2rem",
					gap: { xs: "1rem", md: "0" },
				}}
			>
				<Box>
					<Typography variant="h3" component="h1">
						{dashboardHeader}
					</Typography>
					<Typography variant="h5" component="h2">
						{dashboardSubheader}
					</Typography>
				</Box>
				<Box>{buttons}</Box>
			</Box>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: "repeat(12, 1fr)",
					gridAutoRows: "140px",
					gap: "2rem",
					rowGap: "3rem",
				}}
			>
				{children}
			</Box>
		</Box>
	);
};

export default DashboardGrid;
